function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.917 12.44c-1.248 0-2.192-.512-2.832-1.536-.544-.864-.816-1.92-.816-3.168 0-1.6.4-3.04 1.2-4.32.832-1.28 2.08-2.304 3.744-3.072l.432.864c-.992.416-1.856 1.072-2.592 1.968-.704.896-1.056 1.808-1.056 2.736 0 .384.048.72.144 1.008a2.735 2.735 0 011.776-.624c.864 0 1.584.288 2.16.864.608.544.912 1.28.912 2.208 0 .864-.304 1.6-.912 2.208-.576.576-1.296.864-2.16.864zm-8.16 0c-1.248 0-2.192-.512-2.832-1.536C.38 10.04.109 8.984.109 7.736c0-1.6.4-3.04 1.2-4.32.832-1.28 2.08-2.304 3.744-3.072l.432.864c-.992.416-1.856 1.072-2.592 1.968-.704.896-1.056 1.808-1.056 2.736 0 .384.048.72.144 1.008a2.735 2.735 0 011.776-.624c.864 0 1.584.288 2.16.864.608.544.912 1.28.912 2.208 0 .864-.304 1.6-.912 2.208-.576.576-1.296.864-2.16.864z",
  fill: "currentColor"
});

var SvgQuotation = function SvgQuotation(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 13,
    viewBox: "0 0 15 13",
    width: 13
  }, props), _ref);
};

export default SvgQuotation;